import { Grid2 as Grid } from "@mui/material";
import { FC, ReactNode } from "react";
import { ContractFormWrapper } from "./ContractFormWrapper";
import { ContractText } from "./ContractText";

interface IContractBodyProps {
  text?: ReactNode;
  html?: string | null;
  form: ReactNode;
  pdfUrl?: File | string | null;
}

export const ContractBody: FC<IContractBodyProps> = ({
  text,
  html,
  form,
  pdfUrl,
}) => {
  return (
    <Grid
      container
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "stretch",
      }}
    >
      <Grid
        size={{ xs: 12, md: 9 }}
        sx={{
          height: { xs: "auto", md: "100%" },
          minHeight: { xs: 600, md: 0 },
        }}
      >
        {pdfUrl ? (
          <iframe
            src={pdfUrl as string}
            title="Документ соглашения"
            width="100%"
            height="100%"
            style={{
              display: "block",
              border: "none",
            }}
          />
        ) : html ? (
          <iframe
            srcDoc={html}
            title="Шаблон соглашения"
            sandbox=""
            width="100%"
            height="100%"
            style={{
              display: "block",
              border: "none",
              backgroundColor: "#fff",
            }}
          />
        ) : (
          <ContractText>{text}</ContractText>
        )}
      </Grid>

      <Grid
        size={{ xs: 12, md: 3 }}
        sx={{ height: { xs: "auto", md: "100%" } }}
      >
        <ContractFormWrapper>{form}</ContractFormWrapper>
      </Grid>
    </Grid>
  );
};
